module.exports = __webpack_public_path__ + "static/media/fondo_item.7be2eb2b.png";